/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getDealerDetailsAsync } from './DataActionExtension.g';
import { IDealerEntity } from './DataServiceEntities.g';

/**
 * GetManufacturerCodes Input Action
 */
export class GetDealerDetailsInput implements Msdyn365.IActionInput {
    public dealerId: string;
    constructor(dealerId: string) {
        this.dealerId = dealerId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DealerDetails-store-${this.dealerId}`;
    public getCacheObjectType = () => 'DealerDetails';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetDealerDetailsData {
    dealerDetails: IDealerEntity[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createDealerDetailsInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    // @ts-expect-error
    const dealerId = args.requestContext.query.dealerId;
    return new GetDealerDetailsInput(dealerId);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
// async function action(input: GetDealerDetailsInput, ctx: Msdyn365.IActionContext): Promise<IGetDealerDetailsData> {
async function action(input: GetDealerDetailsInput, ctx: Msdyn365.IActionContext): Promise<IDealerEntity[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = await getDealerDetailsAsync({ callerContext: ctx }, input.dealerId);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IDealerEntity[]>>action,
    // TODO: Give your data action a unique id
    id: 'GetDealerDetails',
    input: createDealerDetailsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
